import React from "react";
import "../styles.css"

const Loading = () => {
  return (
    <div className="loading-container">
      <img
        src="/Loading_png.png" // Path to your image in the public folder
        alt="Loading"
        className="loading-image"
      />
    </div>
  );
};

export default Loading;
